import { useState } from "react";
import { contact } from "../data/portfolioData";
import InquiryForm from "./InquiryForm";

function ChapterContact() {
  const [copied, setCopied] = useState(false);
  const copyEmail = async () => {
    await navigator.clipboard.writeText(contact.email);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 2200);
  };
  return (
    <section id="contact" className="chapter contact-section" data-section="contact" data-testid="chapter-05-contact">
      <div className="contact-panel">
        <div className="section-kicker"><span>05</span><span>INITIATION &amp; DIALOGUE</span></div>
        <div className="contact-heading"><h2 data-testid="chapter-05-heading">Have a difficult problem?<br /><em>Start there.</em></h2><p>For keynotes, architecture conversations, customer workshops, or a thoughtful exchange about what comes next.</p></div>
        <div className="contact-actions">
          <a className="contact-link primary-contact" href={`mailto:${contact.email}`} data-testid="contact-email-link"><span>EMAIL</span>{contact.email}<b>↗</b></a>
          <a className="contact-link" href={contact.linkedin} target="_blank" rel="noreferrer" data-testid="contact-linkedin-link"><span>LINKEDIN</span>Open professional profile<b>↗</b></a>
          <button className="copy-email" type="button" onClick={copyEmail} data-testid="contact-copy-email-btn"><span>{copied ? "COPIED" : "COPY EMAIL"}</span><b>{copied ? "✓" : "＋"}</b></button>
          <span className="contact-status" role="status" aria-live="polite" data-testid="contact-copy-status-alert">{copied ? "Email copied to your clipboard." : "Kuala Lumpur · available globally"}</span>
        </div>
      </div>
      <InquiryForm />
    </section>
  );
}

export default ChapterContact;
